import { RegisterFormButtons } from '../RegisterFormButtons';

type Props = {
  onClose: () => void;
};

export function ModalFooter({ onClose }: Props) {
  return (
    <div className="flex items-center justify-center bg-white rounded-b-lg -mx-6 -mb-6 p-4 !mt-4">
      <RegisterFormButtons onClickCancel={onClose} />
    </div>
  );
}
